import { render, staticRenderFns } from "./StatsList.vue?vue&type=template&id=5a95d8e8&scoped=true&"
import script from "./StatsList.vue?vue&type=script&lang=js&"
export * from "./StatsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95d8e8",
  null
  
)

export default component.exports